import { HttpClient } from './types';

export interface TiendaInfoDTO {
  id: number;
  nombreTienda: string | null;
  descripcionTienda: string | null;
  textoCopyright: string | null;
  direccionLinea1: string | null;
  direccionLinea2: string | null;
  telefonoLabel: string | null;
  telefonoHref: string | null;
  email: string | null;
  whatsappNumero: string | null;
  whatsappHabilitado: boolean;
  instagram: string | null;
  facebook: string | null;
  twitter: string | null;
}

export const createTiendaInfoService = (httpClient: HttpClient) => {
  return {
    get: (): Promise<TiendaInfoDTO> => {
      return httpClient.get<TiendaInfoDTO>('/tienda/informacion-tienda');
    },
  };
};
